<template>
  <div
      class="bg-blue rounded-[56px] mb-4 sm:mb-8 flex items-center relative h-[414px]"
      :style="{
      backgroundImage: `url(${require('@/assets/images/lotto-banner.webp')})`,
      backgroundSize: '813px 100%',
      backgroundPosition: 'right center',
      backgroundRepeat: 'no-repeat',
      marginTop: '30px',
      
    }"
  >
    <div
        class="absolute inset-0 bg-gradient-to-r from-[#01325C] via-[#01325C] to-[#F20544] opacity-55 rounded-[56px]"
        aria-hidden="true"
    ></div>
    <div class="mt-[466px] mb-4 h-full sm:hidden mx-auto flex justify-center">
      <PowerballCard/>
    </div>

    <div class="sm:block hidden justify-center ml-[80px]">
      <PowerballCard/>
    </div>
    <div
        class="sm:absolute bottom-0 sm:left-1/2 transform lg:-translate-x-1/2 -translate-x-8 hidden sm:flex gap-1 bg-blue sm:px-2 lg:px-6 md:pt-3 pt-2 pb-0 rounded-t-3xl"
    >
      <button
          v-for="button in buttons"
          :key="button.id"
          :class="{
          'bg-white text-blue': activeButton === button.id,
          'bg-blue text-white': activeButton !== button.id,
          'lg:px-5 px-2 py-2 rounded-t-3xl font-medium': true,
        }"
          @click="setActiveButton(button.id)"
      >
        {{ button.label }}
      </button>
    </div>
  </div>
  <div
      class="relative sm:hidden flex gap-2 bg-blue mx-auto w-[300px] px-4 py-3 mb-12 mt-[130px] rounded-3xl justify-center"
  >
<!--    <button-->
<!--        v-for="button in buttons"-->
<!--        :key="button.id"-->
<!--        :class="{-->
<!--        'bg-white text-blue': activeButton === button.id,-->
<!--        'bg-blue text-white': activeButton !== button.id,-->
<!--        'lg:px-5 px-3 py-2 rounded-3xl font-medium': true,-->
<!--      }"-->
<!--        @click="setActiveButton(button.id)"-->
<!--    >-->
<!--      {{ button.label }}-->
<!--    </button>-->
  </div>
</template>

<script>
import PowerballCard from "@/components/PowerballCard.vue";

export default {
  data() {
    return {
      activeButton: "playNow",
      buttons: [
        {id: "playNow", label: "Play Now"},
      ],
    };
  },
  methods: {
    setActiveButton(buttonId) {
      this.activeButton = buttonId;
      if (buttonId == "viewResult") {
        window.location.replace("https://lotto724.com/en/powerball/result");
      } else if (buttonId == "howToPlay") {
        window.location.replace("https://lotto724.com/en/mini-lotto/how-to-play");
      }
    },
  },
  name: "BannerSection",
  components: {
    PowerballCard,
  },
};
</script>

<style scoped></style>
